import { useParams } from "react-router-dom";

/**
 * Hook to get the parent path of the current DatasetFileBrowser view.
 *
 * @returns The parent path of the current file browser view.
 */
export const useFileBrowserParentPath = () => {
  const params = useParams();

  return params["*"];
};
